import { render } from "./SignUpProfile.vue?vue&type=template&id=95b8d350&scoped=true&ts=true"
import script from "./SignUpProfile.vue?vue&type=script&lang=ts"
export * from "./SignUpProfile.vue?vue&type=script&lang=ts"

import "./SignUpProfile.vue?vue&type=style&index=0&id=95b8d350&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Anton\\Workspaces\\htdocs\\devloader-userspace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95b8d350"]])

export default __exports__